import { defineColumn, type StrictColumnDef } from '../../tanstack-table/column';

export const LineNumber: StrictColumnDef<unknown> = defineColumn<unknown>({
  id: '#',
  minWidth: 50,
  accessorFn: () => '',
  cell: ({ row, table }) => {
    const visualIndex = table.getSortedRowModel().flatRows.findIndex((r) => r.id === row.id);

    return <>{visualIndex + 1}</>;
  },
});
